<template>
  <v-app :style="{background: this.$vuetify.theme.themes.light.background}">
    <v-content>
        <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12">
                    <v-btn color="primary" :to="{name: 'Dashboard'}">
                        <v-icon>mdi-arrow-left-bold-hexagon-outline</v-icon>戻る
                    </v-btn>
                </v-col>
                <!-- alert -->
                <v-col cols="12" lg="8" md="12">
                    <v-alert v-model="alert" dense type="info" dismissible>
                        今日もいい天気
                    </v-alert>
                    <v-alert v-model="alert" dense type="error" dismissible>
                        今日は雨
                    </v-alert>
                </v-col>
                <!-- avatars -->
                <v-col cols="12">
                    <v-avatar color="indigo">
                        <v-icon>mdi-baguette</v-icon>
                    </v-avatar>
                    <v-divider class="mx-4" vertical></v-divider>
                    <v-avatar color="indigo">
                        <span class="white--text headline">堤</span>
                    </v-avatar>
                </v-col>
                <!-- breadcrumbs -->
                <v-col cols="12">
                    <v-breadcrumbs :items="breadcrumbs_items" divider=">"></v-breadcrumbs>
                </v-col>
                <!-- buttons -->
                <v-col cols="12">
                    <v-btn class="mr-2 mb-2" depressed color="primary">閲覧</v-btn>
                    <v-btn class="mr-2 mb-2" depressed color="secondary">これは使わない</v-btn>
                    <v-btn class="mr-2 mb-2" depressed color="accent"><v-icon small>mdi-police-badge</v-icon>禁止</v-btn>
                    <v-btn class="mr-2 mb-2" depressed color="error">削除</v-btn>
                    <v-btn class="mr-2 mb-2" depressed color="info">確認</v-btn>
                    <v-btn class="mr-2 mb-2" depressed color="success">作成</v-btn>
                    <v-btn class="mr-2 mb-2"  depressed color="warning">警告</v-btn>
                </v-col>
                <!-- cards -->
                <v-row>
                    <v-col cols="12" lg="4" md="6">
                        <v-card class="mx-auto">
                            <v-list-item>
                                <v-list-item-avatar color="grey"><v-icon>mdi-baguette</v-icon></v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title class="headline">ASD株式会社</v-list-item-title>
                                    <v-list-item-subtitle>by Yoshinaga</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-img src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg" height="194"></v-img>
                            <v-card-text>
                                有一無二のプログラマーかもしれない。
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" lg="4" md="6">
                        <v-card class="mx-auto">
                            <v-list-item>
                                <v-list-item-avatar color="grey"><v-icon>mdi-baguette</v-icon></v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title class="headline">ASD株式会社</v-list-item-title>
                                    <v-list-item-subtitle>by ueda</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-img src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg" height="194"></v-img>
                            <v-card-text>
                                有一無二のRPA使いかもしれない。
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" lg="4" md="6">
                        <v-card class="mx-auto">
                            <v-list-item>
                                <v-list-item-avatar color="grey"><v-icon>mdi-baguette</v-icon></v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title class="headline">ASD株式会社</v-list-item-title>
                                    <v-list-item-subtitle>by kikuchi</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-img src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg" height="194"></v-img>
                            <v-card-text>
                                有一無二の骨折した人かもしれない。
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-col cols="12">
                    <v-dialog v-model="dialog" persistent max-width="290">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" v-on="on">ASD株式会社の確認</v-btn>
                        </template>
                        <v-card>
                            <v-card-title class="headline">ASD株式会社</v-card-title>
                            <v-card-text>謎のプログラマー集団</v-card-text>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="gray" text @click="dialog = !dialog">わからない</v-btn>
                            <v-btn color="green" text @click="dialog = !dialog">わかった</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-col>
                <!-- forms -->
                <v-col cols="12" lg="6" md="8">
                    <v-card class="mx-auto">
                        <v-card-text>
                            <form>
                                <v-col cols="12" lg="8" md="12">
                                    <v-combobox v-model="combobox_select" :items="combobox_items" label="骨折しているのは誰" outlined dense></v-combobox>
                                </v-col>
                                <v-text-field label="名前" v-model="name" :counter="10" :rules="nameRules" required></v-text-field>
                                <v-text-field label="メールアドレス" v-model="email" :rules="emailRules" required></v-text-field>
                                <v-checkbox v-model="check" label="吉永" input-value="true" hide-details></v-checkbox>
                                <v-checkbox label="上田" input-value="true" disabled></v-checkbox>
                                <v-radio-group v-model="radios" :mandatory="false">
                                    <v-radio label="上田" value="radio_value"></v-radio>
                                    <v-radio label="菊池" value="radio_value"></v-radio>
                                </v-radio-group>
                                <v-slider v-model="slide_value" :rules="slideRules" label="吉永くんの年齢は？" step="10" thumb-label="always" ticks></v-slider>
                                <v-textarea class="mx-2" label="prepend-icon" rows="1" prepend-icon="mdi-tooltip-text"></v-textarea>
                                <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="date" label="吉永くんの誕生日は？" clearable prepend-icon="mdi-calendar-blank" readonly v-on="on" ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
                                </v-menu>
                            </form>
                        </v-card-text>
                    </v-card>
                </v-col>
                <!-- progress -->
                <v-col cols="12">
                    <v-btn class="mr-2 mb-2" depressed color="primary" @click="overlay = !overlay">ローディング</v-btn>
                    <v-overlay :value="overlay">
                        <v-progress-circular class="mb-2" :size="50" color="primary" indeterminate></v-progress-circular>
                        <v-btn icon @click="overlay = !overlay">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-overlay>
                </v-col>
                <!-- datatables -->
                <v-col cols="12" lg="8">
                    <v-data-table :headers="headers" :items="desserts" :footer-props="footers" :search="search" :single-select="singleSelect" show-select dense>
                        <template v-slot:no-data>
                            データがありません
                        </template>
                        <template slot="footer.page-text" slot-scope="props">
                            {{ props.itemsLength }} 件中 {{ props.pageStart }} 件目 〜 {{ props.pageStop }} 件目
                        </template>
                    </v-data-table>
                </v-col>
                <!-- treeview -->
                <v-col cols="12" lg="8">
                    <v-card>
                        <v-card-title>
                            <v-text-field v-model="treeview_search" label="検索" flat solo-inverted hide-details clearable 
                                clear-icon="mdi-close-circle-outline"></v-text-field>
                        </v-card-title>
                        <v-card-text>
                            <v-treeview :items="treeview_items" :search="treeview_search" :filter="filter" :open.sync="open">
                                <template v-slot:prepend="{ item }">
                                <v-icon
                                    v-if="item.children"
                                    v-text="`mdi-${item.id === 1 ? 'home-variant' : 'folder-network'}`"
                                ></v-icon>
                                </template>
                            </v-treeview>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    name: "Sample",
    data: () => ({
        // alerts
        alert: true,
        // breadcrumbs
        breadcrumbs_items: [
            {
                text: 'ダッシュボード',
                disabled: false,
                href: '/dashboard',
            },
            {
                text: 'ダッシュボード',
                disabled: false,
                href: '/dashboard',
            },
            {
                text: 'ダッシュボード',
                disabled: true,
                href: '/dashboard',
            },
        ],
        // dialog
        dialog: false,
        // Forms
        // combobox
        combobox_select: [],
        combobox_items: [
          '吉永',
          '菊池',
          '上田',
        ],
        // input
        name: '',
        nameRules: [
            v => !!v || '名前は必須項目です',
            v => v.length <= 10 || '名前は10文字以内で入力してください',
        ],
        email: '',
        emailRules: [
            v => !!v || 'メールアドレスは必須項目です',
            v => /.+@.+/.test(v) || 'メールアドレスの形式で入力してください',
        ],
        // checkbox
        checkbox: '',
        // radio
        radio_value: '',
        // slider
        slide_value: 0,
        slideRules: [
          v => v <= 60 || 'おしい!!',
        ],
        // datepicker
        date: new Date().toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        // overlay
        overlay: false,
        // datatables
        singleSelect: false,
        search: '',
        headers: [
          { text: '吉永', align: 'left', sortable: false, value: 'yoshinaga' },
          { text: '菊池', align: 'left', sortable: false, value: 'kikuchi' },
          { text: '上田', align: 'left', sortable: false, value: 'ueda' }
        ],
        desserts: [
          { yoshinaga: '有一無二のプログラマーかもしれない。', kikuchi: '有一無二の骨折した人かもしれない。', ueda: '有一無二のRPA使いかもしれない。' },
          { yoshinaga: '有一無二のプログラマーかもしれない。', kikuchi: '有一無二の骨折した人かもしれない。', ueda: '有一無二のRPA使いかもしれない。' },
          { yoshinaga: '有一無二のプログラマーかもしれない。', kikuchi: '有一無二の骨折した人かもしれない。', ueda: '有一無二のRPA使いかもしれない。' },
          { yoshinaga: '有一無二のプログラマーかもしれない。', kikuchi: '有一無二の骨折した人かもしれない。', ueda: '有一無二のRPA使いかもしれない。' },
          { yoshinaga: '有一無二のプログラマーかもしれない。', kikuchi: '有一無二の骨折した人かもしれない。', ueda: '有一無二のRPA使いかもしれない。' },
          { yoshinaga: '有一無二のプログラマーかもしれない。', kikuchi: '有一無二の骨折した人かもしれない。', ueda: '有一無二のRPA使いかもしれない。' },
          { yoshinaga: '有一無二のプログラマーかもしれない。', kikuchi: '有一無二の骨折した人かもしれない。', ueda: '有一無二のRPA使いかもしれない。' },
          { yoshinaga: '有一無二のプログラマーかもしれない。', kikuchi: '有一無二の骨折した人かもしれない。', ueda: '有一無二のRPA使いかもしれない。' },
          { yoshinaga: '有一無二のプログラマーかもしれない。', kikuchi: '有一無二の骨折した人かもしれない。', ueda: '有一無二のRPA使いかもしれない。' },
          { yoshinaga: '有一無二のプログラマーかもしれない。', kikuchi: '有一無二の骨折した人かもしれない。', ueda: '有一無二のRPA使いかもしれない。' },
          { yoshinaga: '有一無二のプログラマーかもしれない。', kikuchi: '有一無二の骨折した人かもしれない。', ueda: '有一無二のRPA使いかもしれない。' },
          { yoshinaga: '有一無二のプログラマーかもしれない。', kikuchi: '有一無二の骨折した人かもしれない。', ueda: '有一無二のRPA使いかもしれない。' },
        ],
        footers: {
            itemsPerPageOptions: [10]
        },
        // treeview
        treeview_items: [
        {
          id: 1,
          name: 'ASD株式会社',
          children: [
            {
              id: 2,
              name: 'システム開発部 1課',
              children: [
                {
                  id: 201,
                  name: '菊池',
                },
                {
                  id: 202,
                  name: '吉永',
                },
              ],
            },
            {
              id: 3,
              name: 'ヘルスケア事業部',
              children: [
                {
                  id: 301,
                  name: '上田',
                }
              ],
            },
          ],
        },
      ],
      open: [1, 2],
      treeview_search: null,
    }),
    computed: {
      filter () {
        return (item, search, textKey) => item[textKey].indexOf(search) > -1
      },
    },
  }
</script>